exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-rating__checkbox {\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  border: 0;\n}\n.star-rating__star {\n  display: inline-block;\n  padding: 3px;\n  vertical-align: middle;\n  line-height: 36px;\n  font-size: 30px;\n  color: #ababab;\n  transition: color 0.2s ease-out;\n}\n.star-rating__star:hover {\n  cursor: pointer;\n}\n.star-rating__star.is-selected {\n  color: #ffd700;\n}\n.star-rating__star.is-disabled:hover {\n  cursor: default;\n}", ""]);

// exports
